import { useTranslation } from 'react-i18next';

export default function Testimonial() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-secondary-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[40%] w-full">
            <div className="w-full aspect-[4/5] rounded-[32px] overflow-hidden bg-secondary-200">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20young%20woman%20working%20on%20silver%20laptop%20at%20charming%20European%20outdoor%20cafe%20terrace%20with%20wrought%20iron%20table%2C%20busy%20cobblestone%20street%20and%20historic%20architecture%20visible%20in%20blurred%20background%2C%20genuine%20joyful%20smile%2C%20casual%20elegant%20autumn%20outfit%20with%20scarf%2C%20soft%20overcast%20daylight%2C%20authentic%20lifestyle%20street%20photography%20with%20natural%20expression%20and%20warm%20urban%20tones&width=800&height=1000&seq=testimonial-v2-2026&orientation=portrait"
                alt="Zadowolona użytkowniczka Kakobuy Spreadsheet"
                title="Zadowolona użytkowniczka Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[60%] w-full">
            <span className="text-sm text-foreground-500 font-medium">
              {t('testimonial.label')}
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              {t('testimonial.title1')}<br />
              <span className="text-foreground-400">{t('testimonial.title2')}</span>
            </h2>
            <blockquote className="mt-8 text-base md:text-lg text-foreground-600 leading-relaxed italic border-l-4 border-secondary-300 pl-6">
              &ldquo;{t('testimonial.quote')}&rdquo;
            </blockquote>
            <p className="mt-6 text-sm font-semibold text-foreground-800">
              &mdash; {t('testimonial.author')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}